<template>
    <div class="view-container">
        <div class="view-placeholder"></div>
        <div class="view-content">
            <div class="view-content-text">
                <h1>Tarefas ✔️</h1>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ViewTasks"
}
</script>